import { DirectorySourceTypes } from "../directory.types";
import { IExternalDirectoryRecord } from "./types";

const directoryContactsParser = (contacts: IExternalDirectoryRecord[]) =>
    contacts.map((contact) => directoryContactParser(contact));

export const directoryContactParser = (contact: IExternalDirectoryRecord): IExternalDirectoryRecord => ({
    sourceType: DirectorySourceTypes.EXTERNAL_DIRECTORY,
    ...contact,
});

export default directoryContactsParser;
